import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.15_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.15_react-dom@19.2.5_react@19.2.5__react@19.2.5/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/world-cup/styles.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/match/[slug]/styles.css");
